import classes from './ChatWidget.module.scss'
import { IconBot, IconClose } from './icons'

interface Props {
  /** Balonun gövdesine tıklandı → panel açılır. */
  onOpen: () => void
  /** X'e tıklandı → hatırlatma kalıcı olarak susturulur. */
  onDismiss: () => void
}

/**
 * FAB'in solunda açılan hafif hatırlatma balonu: tam tanıtımı görmüş hesaplara, asistanın
 * varlığını kısaca hatırlatır. Gövde ve kapat butonu kardeş `<button>` öğeleridir
 * (iç içe buton kurulmaz).
 */
export default function IntroNudge({ onOpen, onDismiss }: Props) {
  return (
    <div className={classes.introNudge} role='status' aria-live='polite'>
      <button type='button' className={classes.introNudgeBody} onClick={onOpen}>
        <span className={classes.introNudgeAvatar}>
          <IconBot />
        </span>
        <span className={classes.introNudgeText}>
          <strong>Merhaba, ben B-Gini 👋</strong>
          Sipariş, stok ve cari sorularınızı bana sorabilirsiniz.
        </span>
      </button>
      <button type='button' className={classes.introNudgeClose} onClick={onDismiss} aria-label='Tanıtımı kapat'>
        <IconClose />
      </button>
    </div>
  )
}
